import React from 'react';
import PropTypes from 'prop-types';
import ReadOnlyService from '../app/services/ReadOnlyService';

const ActionIcon = (propsParam) => {
  const props = {
    size: 'lg',
    ...propsParam
  };

  let className;

  if (props.icon) {
    if (props.icon.includes('fab')) {
      className = 'fab ';
    }
    else if (props.icon.includes('far')) {
      className = 'far ';
    }
    else if (props.icon.includes('fas')) {
      className = '';
    }
    else {
      className = 'fas ';
    }
    className += ' ' + props.icon;
  }

  if (props.size) {
    className += ' fa-' + props.size;
  }

  const mutationIcon = /(save|pencil|edit|trash|delete|plus|add|upload|update|send|paper-plane|envelope)/i.test(props.icon || '');
  const readonlyBlocked = ReadOnlyService.isFacilityReadOnly() && mutationIcon;

  const classNames = (props.className ? props.className + ' ' : '') + className + (readonlyBlocked ? ' disabled text-muted' : '');
  const clickHandler = readonlyBlocked ? undefined : (props.action || props.onClick);

  return <i {...props} className={classNames} onClick={clickHandler} />;
};

ActionIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  action: PropTypes.func
};

export default ActionIcon;